<app-auth-layout>
<div class="container">
  <h1>{{ newPasswordContent()?.title }}</h1>
  <span>{{ newPasswordContent()?.title }}</span>
  <form [formGroup]="formCreateNewPasword" (ngSubmit)="onSubmit()">
    <div class="input-container">
      <input
        [type]="showPassword ? 'text' : 'password'"
        class="form-control"
        formControlName="password"
        required
        placeholder="{{ newPasswordContent()?.newPasswordLabel }}"/>
      <button
        type="button"
        class="toggle-password-btn"
        (click)="togglePasswordVisibility()">
        <mat-icon class="eye-icon">
          {{ showPassword ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </button>
    </div>

    <div class="input-container">
      <input
        [type]="showConfirmPassword ? 'text' : 'password'"
        class="form-control"
        formControlName="newPasword"
        required
        placeholder="{{ newPasswordContent()?.confirmNewPasswordLabel }}"/>
      <button
        type="button"
        class="toggle-password-btn"
        (click)="toggleConfirmPasswordVisibility()">
        <mat-icon class="eye-icon">
          {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </button>
    </div>
    @if(submitted && formCreateNewPasword.invalid){
      <div class="error-felds">
        @if (formCreateNewPasword.get('password')?.errors?.['required']) {
          <ng-container class="container-error">
            <mat-icon class="icon">error</mat-icon>
            {{ newPasswordContent()?.newPasswordRequiredError }}
          </ng-container>
        } @else if (formCreateNewPasword.get('password')?.errors?.['pattern']) {
          <ng-container class="container-error">
            <mat-icon class="icon">error</mat-icon>
            {{ newPasswordContent()?.newPasswordFormatError }}
          </ng-container>
        } @else if (formCreateNewPasword.get('newPasword')?.errors?.['required']) {
          <ng-container class="container-error">
            <mat-icon class="icon">error</mat-icon>
            {{ newPasswordContent()?.confirmNewPasswordRequiredError }}
          </ng-container>
        } @else if (passwordsDoNotMatch) {
          <ng-container class="container-error">
            <mat-icon class="icon">error</mat-icon>
            {{ newPasswordContent()?.passwordMismatchError }}
          </ng-container>
        }
      </div>
    }
    <div class="container-buttons">
      <button type="button" >{{ newPasswordContent()?.cancelButton }}</button>
      <button type="submit" >{{ newPasswordContent()?.nextButton }}</button>
    </div>
  </form>
</div>
</app-auth-layout>
